<template>
  <v-tooltip bottom z-index="600">
    <template #activator="{on}">
      <v-chip v-on="on" :color="color" :text-color="textColor"> <v-icon class="small mr-1 my-2">fa-car</v-icon>{{ text }}</v-chip>
    </template>
    <div>
      <h2>{{ $t("travelService.types.car") }} ({{ $t("global.request") }})</h2>
      {{ $t("travelService.pickupPlace") }}: {{ startPlaceText }}<br />
      {{ $t("travelService.returnDifferentPlace") }} <v-icon small v-if="travelServiceOrderItem.car.end_place_id !== null" color="success">fa-check</v-icon>
      <v-icon small v-else color="error">fa-times</v-icon> <br />
      <template v-if="travelServiceOrderItem.car.end_place_id !== null"> {{ $t("travelService.returnCarPlace") }}: {{ endPlaceText }}<br /> </template>
      {{ $t("travelService.class") }}: {{ carClassTypeText }} <br />
      {{ $t("travelService.pickupDate") }}: {{ travelServiceOrderItem.car.start_date }} {{ travelServiceOrderItem.car.start_time }}<br />
      {{ $t("travelService.returnCarDate") }}: {{ travelServiceOrderItem.car.end_date }} {{ travelServiceOrderItem.car.end_time }}<br />
    </div>
    <travel-service-order-item-common-tooltip-part :travel-service-order-item="travelServiceOrderItem" />
  </v-tooltip>
</template>

<script>
import { allCarTypes } from "../../../staticData/TravelServiceTypes";

import TravelServiceOrderItemCommonTooltipPart from "./TravelServiceOrderItemCommonTooltipPart";
export default {
  name: "TravelServiceOrderItemCarChip",
  components: { TravelServiceOrderItemCommonTooltipPart },
  props: {
    travelServiceOrderItem: { required: true, type: Object },
    color: { required: false, type: String, default: "" },
    textColor: { required: false, type: String, default: "" },
    text: { required: false, type: String, default: "Usługa wynajmu pojazdów" }
  },
  data: () => ({
    startPlaceText: "",
    endPlaceText: ""
  }),
  watch: {
    "travelServiceOrderItem.car.start_place_id"() {
      this.downloadStartPlace();
    },
    "travelServiceOrderItem.car.end_place_id"() {
      this.downloadEndPlace();
    }
  },
  computed: {
    carClassTypeText() {
      if (typeof this.travelServiceOrderItem.car.car_class !== "undefined") {
        return allCarTypes().find(v => v.value === this.travelServiceOrderItem.car.car_class).text;
      }
      return "";
    }
  },
  methods: {
    downloadStartPlace() {
      if (this.travelServiceOrderItem.car.start_place_id !== null) {
        this.$store.dispatch("Location/getLocation", { placeId: this.travelServiceOrderItem.car.start_place_id }).then(result => {
          this.startPlaceText = result.text;
        });
      }
    },
    downloadEndPlace() {
      if (this.travelServiceOrderItem.car.end_place_id !== null) {
        this.$store.dispatch("Location/getLocation", { placeId: this.travelServiceOrderItem.car.end_place_id }).then(result => {
          this.endPlaceText = result.text;
        });
      }
    }
  },
  created() {
    this.downloadStartPlace();
    this.downloadEndPlace();
  }
};
</script>

<style scoped></style>
